import React, { useEffect, useRef, useState } from 'react'
import './manage-evals.styles.scss'

import { format, set } from 'date-fns'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faLink, faRefresh, faPrint, faPen, faEllipsisH, faEllipsisV, faTrash, faChartLine, faSquareArrowUpRight, faArchive } from '@fortawesome/free-solid-svg-icons'
import NewEvalModal from '../new-eval-modal/new-eval-modal.component'
import SearchBar from '../../SHARED/search-bar/search-bar.component'
import { properCase } from '../../../utils/properCase'
import { Link, Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import EditEval from './edit-eval.component'
import EvalDataView from './eval-data-view.component'
import { ModalConfirm } from '../../modal/modal.component'
import FullPageLoader from '../../SHARED/loader/full-page-loader.component'
import CheckInOutData from './check-in-out-data.component'
import { useSelector } from 'react-redux'
import ManageEvalsDropdown from './manage-evals-dropdown.component'
import MobileEvalListAdmin from './mobile-eval-list-admin.component'
import EvalListAdmin from './eval-list-admin.component'
import CreateEvalFormV2 from '../create-eval/create-eval-form-v2.component'
import NewEval from '../create-eval/create-eval.component'

const ManageEvals = ({
  evalList
}) => {

  const screenSize = useSelector(state => state.listsData.screenSize);
  const [evalsToDisplay, setEvalsToDisplay] = useState([]);
  const [newEval, setNewEval] = useState(false);
  const [ confirmMessage, setConfirmMessage ] = useState(null);
  const [ countLimit, setCountLimit ] = useState(20);
  const [ loading, setLoading ] = useState(false);
  const approveRef = useRef(() => {}); 
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!evalList) return;
    console.log(evalList);
    setEvalsToDisplay(Object.values(evalList))
  }, [evalList])

  function search() {
    const searchText = document.getElementById('search-text').value.toLowerCase();
    if (!searchText) {
      setEvalsToDisplay(Object.values(evalList));
      return;
    }
    const filteredEvals = Object.values(evalList).filter(ev => (
      (ev.title && ev.title.toLowerCase().includes(searchText)) ||
      (ev.id && ev.id.toLowerCase().includes(searchText)) ||
      (ev.platform && ev.platform.toLowerCase().includes(searchText)) ||
      (ev.source && ev.source.toLowerCase().includes(searchText))
    ));
    setEvalsToDisplay(filteredEvals);
  }
  // async function updateEvals() {
  //     const res = await UseCloudFunction('updateEvalList', {'data': 'some data'})
  //     console.log(res);
  // }

  function copyUrl(id) {
    const url = `${window.location.origin}/${id}`;
    navigator.clipboard.writeText(url);

    const el = document.getElementById(`${id}-tooltip`);
    if (!el) return;

    el.style.visibility = 'visible';
    const timeout = setTimeout(() => {
        document.getElementById(`${id}-tooltip`).style.visibility = 'hidden';
        timeout && clearTimeout(timeout);
    }, 2000);
  }

  function archiveEval(id) {
    console.log('archive', id);
    setConfirmMessage(`Are you sure you want to archive this evaluation? This action can be undone.`);
    approveRef.current = () => {
      continueArchive();
    }

    async function continueArchive() {

    }
  }

  return (
    <div className={`manage_evals ${screenSize}`}>
      <Routes>
        <Route path="" element={
          <div className='manage_evals_content g-card'>
            {/* <div className='section-title'>
                  <span className='allcaps'>Manage Evaluations</span>
                </div>
                <div className='g-height-40'></div> */}
            <div className='section-head'>
              <h3>Manage Evaluations</h3>
              <button 
                  className='g-button med-btn' 
                  onClick={() => navigate('/admin/create')}>
                  {
                    screenSize === 'mobile'
                    ?
                    'Create'
                    :
                    `Create a New Evaluation`
                  }
                  <FontAwesomeIcon icon={faPlus} />
                </button>
              
            </div>
            <hr />

            <SearchBar search={search} idLabel={'search-text'} />
            {
              (screenSize === 'mobile' || screenSize === 'tablet')
              ?
              <MobileEvalListAdmin 
                evalsToDisplay={evalsToDisplay}
                countLimit={countLimit} />
              :
              <EvalListAdmin
                evalsToDisplay={evalsToDisplay}
                countLimit={countLimit} />
            }
            <div className='g-center-col'>
              <button
                className={`g-button med-btn ${countLimit >= evalsToDisplay?.length ? 'disabled' : ''}`}
                onClick={() => setCountLimit(countLimit + 20)}>
                  More
                </button>
            </div>
          </div>
        }></Route>
        <Route path="/:evalPath/edit" element={
          <NewEval />
        } />
        <Route path="/:evalPath/data" element={
          <EvalDataView
            evalList={evalList} />
        } />
      </Routes>
      <NewEvalModal show={newEval} close={() => setNewEval(false)} />
      <ModalConfirm
        show={confirmMessage}
        cancel={() => setConfirmMessage(null)}
        message={confirmMessage}
        onApprove={approveRef.current} />
      <FullPageLoader show={loading} message={'Processing...'} />
    </div>
  )
}

export default ManageEvals